import React from 'react';
import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';
import * as colors from '@atlaskit/theme/colors';

import { flex, flexCenter } from '@/styles';
import { FCC } from '@/utils/types';

type SearchKeyValueTagProps = {
  title: string;
  isBadge?: boolean;
};

const tagStyles = [
  flexCenter,
  css`
    gap: 6px;
  `,
];

const tagTitleStyles = css`
  font-size: 11px;
  color: ${token('color.text.subtlest', colors.N70)};
  font-weight: 600;
  text-transform: uppercase;
`;

const badgeStyles = css`
  position: relative;
  top: -1px;
  div span {
    font-size: 11px;
  }
`;

const SearchKeyValueTag: FCC<SearchKeyValueTagProps> = ({
  title,
  isBadge = false,
  children,
  ...other
}) => (
  <div css={tagStyles} {...other}>
    <span css={tagTitleStyles}>{title}</span>
    <span css={[flex, isBadge ? badgeStyles : '']}>{children}</span>
  </div>
);

export default SearchKeyValueTag;
